import { render, staticRenderFns } from "./AppStructureFixing.vue?vue&type=template&id=f862fe0c&"
import script from "./AppStructureFixing.vue?vue&type=script&lang=js&"
export * from "./AppStructureFixing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports